import { Divider, Typography, Stack, tokens } from '@cast/design-system';

type ClustersFilterSummaryProps = {
  resultCount: number;
  appliedFilterCount: number;
};

export const ClustersFilterSummary = ({
  resultCount,
  appliedFilterCount,
}: ClustersFilterSummaryProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={8}
      data-testid="clusters-filter-summary"
    >
      <Typography
        component="span"
        variant="P12R"
        color={tokens.theme.fg.structural.secondary}
        sx={{ display: 'inline-flex', alignItems: 'center', gap: '2px' }}
      >
        <Typography component="span" variant="P12B" color="grey.900">
          {resultCount}
        </Typography>
        results
      </Typography>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ height: 18, alignSelf: 'center' }}
      />
      <Typography
        component="span"
        variant="P12R"
        color={tokens.theme.fg.structural.secondary}
        sx={{ display: 'inline-flex', alignItems: 'center', gap: '2px' }}
      >
        <Typography component="span" variant="P12B" color="grey.900">
          {appliedFilterCount}
        </Typography>
        filters applied
      </Typography>
    </Stack>
  );
};
